import React, { memo } from 'react'
import { AuctionShipmentOpsRep } from 'apps/fleet-planner/types'
import { ConfirmationModal } from 'transfix-ui'
import { formatPhone } from 'utils/formatPhone'

interface IOpsRepModal {
  isOpen: boolean
  onClose: () => void
  opsRep: AuctionShipmentOpsRep
}

export const OpsRepModal = memo<IOpsRepModal>(({ isOpen, onClose, opsRep }) => {
  const { email, name, phone } = opsRep
  return (
    <ConfirmationModal
      className='fp-ops-rep-modal'
      title='Contact Info'
      size={4}
      open={isOpen}
      actions={[
        {
          label: 'Close',
          type: 'confirm',
        },
      ]}
      onClose={onClose}>
      <p className='body-medium'>{formatPhone(phone, { removeCountryCode: '+1' })}</p>
      {name && <p>{name}, Carrier Manager at Transfix</p>}
      <a href={`mailto:${email}`}>{email}</a>
    </ConfirmationModal>
  )
})
